import StepModal from "src/pages/steps/StepTilaus/Modals/StepModal";
import LazyLoader from "../layout/Progress/LazyLoader";
import EditVehicle from "./EditVehicle";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function EditVehicleModal({ vehicle, open, onClose }) {
  const [vehicleState, setVehicleState] = useState();

  useEffect(() => {
    if (vehicle && open) setVehicleState(vehicle);
  }, [vehicle, open]);

  return (
    <StepModal
      isOpen={open}
      onClose={onClose}
      dialogProps={{ maxWidth: "xl" }}
      title={"Ajoneuvo " + vehicleState?.vehicleRegNo || ""}
      hideButtons={true}
      showCloseIcon={true}
      rowId={vehicleState?.vehicleId}>
      <LazyLoader>
        <EditVehicle
          open={open}
          vehicle={vehicleState}
          setVehicle={setVehicleState}
          onClose={onClose}
        />
      </LazyLoader>
    </StepModal>
  );
}

EditVehicleModal.propTypes = {
  vehicle: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
